import React from "react";
import PendingApplicationsRoleWise from "./PendingApplicationsRoleWise";

const UserPendingApplications = () => {
  return (
    <PendingApplicationsRoleWise
      status="2,5,11,12"
      title="User Pending Applications Report"
      heading="User Pending Applications"
      pageFrom="user-pending-applications"
    ></PendingApplicationsRoleWise>
  );
};

export default UserPendingApplications;
